import { useQuery } from "@tanstack/react-query";
import { DesignTemplate } from "api/config/chalice-types";
import { fetchTemplates } from "api/templates";

const useDesignTemplates = () => {
  const {
    data: templates = [],
    isLoading,
    error,
  } = useQuery<DesignTemplate[], Error>({
    queryKey: ["designTemplates", { enabled: true }],
    queryFn: () => fetchTemplates({ enabled: true }),
  });

  return { templates, isLoading, error };
};

export default useDesignTemplates;
